import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';

export type FormRowProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  required?: boolean;
  showError?: boolean;
  errorMessage?: string;
};

export const FormRow: React.FC<FormRowProps> = ({
  title,
  children,
  className = '',
  titleClassName = '',
  required = false,
  showError = false,
  errorMessage = '',
}) => {
  const userAgent = useUserAgent();
  const hasFlexDirection = className?.includes('flex-');
  return (
    <div
      className={clsx(
        'flex',
        {
          'flex-col': !userAgent.isDesktop && !hasFlexDirection,
          'flex-wrap': !userAgent.isDesktop && hasFlexDirection,
          'grid grid-cols-12 items-center gap-4': userAgent.isDesktop,
        },
        className
      )}
    >
      {title && (
        <div
          className={clsx(
            'text-left text-sm font-bold',
            {
              'mb-1': !userAgent.isDesktop,
              'col-span-4 font-medium pl-4': userAgent.isDesktop,
            },
            titleClassName
          )}
        >
          {`${title} ${required ? '*' : ''}`}
        </div>
      )}

      <div
        className={clsx('flex justify-start', {
          'flex-1 min-w-0': !userAgent.isDesktop && hasFlexDirection,
          'col-span-8': userAgent.isDesktop && title,
          'col-span-12': userAgent.isDesktop && !title,
        })}
      >
        {children}
      </div>

      {showError && (
        <div
          className={clsx({
            'basis-full': !userAgent.isDesktop && hasFlexDirection,
            'col-span-12 col-start-5': userAgent.isDesktop && title,
            'col-span-12': userAgent.isDesktop && !title,
          })}
        >
          <div className="mt-1 flex items-center justify-start text-xs text-red-500">
            <ExclamationCircleIcon className="mr-1 size-3" />
            <span>{errorMessage}</span>
          </div>
        </div>
      )}
    </div>
  );
};
